export function expandSizes(raw: string): string[] {
	return raw.split(',').flatMap((part) => {
		const value = part.trim()
		if (!value) return []

		const match = value.match(/^(.+?)\s*[xх]\s*(\d+)$/)
		if (!match) return [value]

		const name = match[1]!.trim()
		const count = Number(match[2])
		if (!name || !Number.isSafeInteger(count) || count < 1) return [value]

		return Array.from({ length: count }, () => name)
	})
}
